module.exports = __webpack_public_path__ + "static/media/292x0w (6).44ac69f6.webp";